export enum ECaptchaProvider {
  Recaptcha = 'recaptcha', // default
  Turnstile = 'turnstile',
}
